import { connect } from "react-redux";

import { getStreamStates } from "../../store/sportkeymoment/duck";
import {
  fetchAccessControl,
  fetchMe,
  getClientSetting,
  getFeatureList,
  getOrganizationProcessingLimit,
  getOrganizationsByIds,
  getUserOrganizations,
  getUserWorkspaces,
} from "../../store/user/duck";
import {
  getAllCategory,
  getCategoryConfiguration,
  getCloudPreSignedURL,
  getDownloadStatus,
  getDownloadVideo,
  getDownloadVideoStatus,
  getPresignedUrl,
} from "../../store/videogrid/duck";
import LayoutComponent from "./component";

const LayoutContainer = connect(
  // Map state to props
  (/*state*/) => ({}),
  // Map actions to dispatch and props
  {
    fetchMe,
    getClientSetting,
    getStreamStates,
    getOrganizationProcessingLimit,
    fetchAccessControl,
    getPresignedUrl,
    getDownloadStatus,
    getCategoryConfiguration,
    getOrganizationsByIds,
    getFeatureList,
    getUserOrganizations,
    getUserWorkspaces,
    getAllCategory,
    getDownloadVideoStatus,
    getDownloadVideo,
    getCloudPreSignedURL,
  },
)(LayoutComponent);

export default LayoutContainer;
